import { BreakoutAlert } from 'components/design-system/BreakoutAlert'
import { ErrorIcon } from 'components/icons/Error'
import { Trans } from 'react-i18next'
import type { AccessCodeError } from './accessCodeError'

const SUPPORT_EMAIL = 'support@breakoutlearning.com'

/**
 * The error under the access code row (input and button), as a danger
 * BreakoutAlert: what went wrong, the fix, and a support fallback.
 */
export function AccessCodeErrorCallout({
  error,
  id,
}: {
  error: AccessCodeError
  id?: string
}) {
  return (
    <div id={id} role="alert" data-testid="access-code-error">
      <BreakoutAlert
        variant="danger"
        className="text-left"
        icon={<ErrorIcon size={20} className="shrink-0 text-core-error" />}
      >
        <div className="font-semibold">{error.title}</div>
        {(error.body || error.support) && (
          <div>
            {error.body}
            {error.body && error.support && ' '}
            {error.support && (
              <Trans
                i18nKey="pages.student.assignment.dialogs.purchase_or_enroll.access_code_errors.support"
                components={{
                  email: (
                    <a className="underline" href={`mailto:${SUPPORT_EMAIL}`}>
                      {/* Trans swaps this for the <email> text in the
                          translation; it is here so the link always has
                          readable content */}
                      {SUPPORT_EMAIL}
                    </a>
                  ),
                }}
              />
            )}
          </div>
        )}
      </BreakoutAlert>
    </div>
  )
}
